import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { trendingTags } from '@/mocks/categories';
import { useEffect } from 'react';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const articleId = parseInt(id || '0', 10);
  const article = articles.find((a) => a.id === articleId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-heading text-foreground-950 mb-4">文章不存在</h1>
            <p className="text-foreground-500">该爆料可能已被删除或链接无效。</p>
            <Link
              to="/"
              className="inline-block mt-4 text-accent-500 hover:text-accent-600 font-medium"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.categorySlug === article.categorySlug && a.id !== article.id)
    .slice(0, 3);

  const articleContentSections = [
    `<p>据知情人士透露，${article.title.replace(/^某/, '')}。</p>`,
    `<p>消息人士称，该事件最早在社交平台被网友曝光，随后迅速发酵。多位圈内人士在接受采访时表示对此事"略有所闻"，但均不愿透露更多细节。</p>`,
    `<p>从目前掌握的线索来看，此事可能还会牵扯出更多相关人物。有分析认为，这只是冰山一角，后续或将有更大规模的爆料浮出水面。</p>`,
    `<h2 class="text-xl font-bold text-foreground-950 mt-6 mb-3">事件时间线</h2>`,
    `<p>据悉，该事件的导火索最早可以追溯到今年年初。当时就有零星的讨论在各大社交平台出现，但由于缺乏实锤证据，并未引起广泛关注。</p>`,
    `<p>直到最近，随着更多细节被逐一曝光，事件才真正进入大众视野。从最初的零星讨论到现在的全网热议，整个过程不过短短数周时间。</p>`,
    `<h2 class="text-xl font-bold text-foreground-950 mt-6 mb-3">各方反应</h2>`,
    `<p>截至目前，当事人及其团队尚未对此事做出正式回应。其工作室官方账号保持沉默，最新一条动态仍停留在三天前的一条日常营业内容。</p>`,
    `<p>与此同时，当事人的粉丝群体内部也出现了明显的分裂。一部分铁粉坚持认为这是"造谣抹黑"，另一部分则态度发生了动摇。</p>`,
    `<h2 class="text-xl font-bold text-foreground-950 mt-6 mb-3">网友热议</h2>`,
    `<p>相关话题在社交媒体上引发了热烈讨论。有网友表示："早就觉得不太对劲了，果然还是爆出来了。"也有理性的声音提醒大家："在没有官方回应之前，还是不要轻易下结论。"</p>`,
    `<p>无论如何，这无疑是近期最受关注的八卦事件之一。51吃瓜网站将继续关注事件进展，为大家带来最新报道。</p>`,
  ];

  return (
    <>
      <Navbar />
      <main>
        <article>
          {/* Breadcrumb */}
          <div className="pt-20 pb-4 bg-background-50">
            <div className="max-w-4xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: article.category, href: `/category/${article.categorySlug}` },
                  { label: article.title },
                ]}
              />
            </div>
          </div>

          {/* Article Header */}
          <header className="bg-background-50 pb-8">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <div className="flex gap-2 mb-4">
                <Link
                  to={`/category/${article.categorySlug}`}
                  className="bg-accent-500 text-background-50 text-xs px-3 py-1 rounded-full font-medium hover:bg-accent-600 transition-colors"
                >
                  {article.category}
                </Link>
                {article.isHot && (
                  <span className="bg-primary-600 text-background-50 text-xs px-3 py-1 rounded-full font-medium flex items-center gap-1">
                    <i className="ri-fire-line text-[10px]"></i>热门
                  </span>
                )}
                {article.isNew && (
                  <span className="bg-secondary-500 text-background-50 text-xs px-3 py-1 rounded-full font-medium">
                    新瓜
                  </span>
                )}
              </div>

              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-black text-foreground-950 leading-tight mb-4">
                {article.title}
              </h1>

              <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500">
                <div className="flex items-center gap-2">
                  <img
                    src={article.authorAvatar}
                    alt={article.author}
                    className="w-8 h-8 rounded-full object-cover"
                  />
                  <div>
                    <p className="font-medium text-foreground-800 text-xs">{article.author}</p>
                    <p className="text-xs text-foreground-400">特约爆料人</p>
                  </div>
                </div>
                <span className="text-foreground-300">|</span>
                <time dateTime={article.date}>{article.date}</time>
                <span className="text-foreground-300">|</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.readCount > 10000
                    ? `${(article.readCount / 10000).toFixed(1)}万`
                    : article.readCount}{' '}
                  阅读
                </span>
                <span className="text-foreground-300">|</span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line"></i>
                  {article.commentCount} 评论
                </span>
              </div>
            </div>
          </header>

          {/* Cover Image */}
          <div className="max-w-4xl mx-auto px-4 md:px-6 mb-8">
            <div className="rounded-xl overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                title={article.title}
                className="w-full aspect-[16/9] object-cover object-top"
              />
            </div>
          </div>

          {/* Article Content */}
          <section className="pb-10 bg-background-50">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <div
                className="prose-custom text-foreground-800 leading-relaxed text-sm md:text-base space-y-4"
                dangerouslySetInnerHTML={{
                  __html: articleContentSections.join('\n'),
                }}
              />

              {/* Tags */}
              <div className="flex flex-wrap gap-2 mt-8 pt-6 border-t border-background-200">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs bg-background-100 text-foreground-600 px-3 py-1.5 rounded-full hover:bg-accent-100 hover:text-accent-800 transition-colors cursor-pointer"
                  >
                    #{tag}
                  </span>
                ))}
              </div>

              {/* Share */}
              <div className="flex items-center gap-3 mt-6">
                <span className="text-sm text-foreground-500">分享到：</span>
                <button className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer" aria-label="分享到微博">
                  <i className="ri-weibo-line"></i>
                </button>
                <button className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer" aria-label="分享到微信">
                  <i className="ri-wechat-line"></i>
                </button>
                <button className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer" aria-label="复制链接">
                  <i className="ri-link"></i>
                </button>
              </div>
            </div>
          </section>

          {/* Related Articles */}
          {relatedArticles.length > 0 && (
            <section className="py-10 bg-background-100">
              <div className="max-w-7xl mx-auto px-4 md:px-6">
                <h2 className="text-2xl font-heading font-black text-foreground-950 mb-6">
                  相关爆料
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {relatedArticles.map((ra) => (
                    <ArticleCard key={ra.id} article={ra} />
                  ))}
                </div>
              </div>
            </section>
          )}
        </article>
      </main>

      {/* Schema.org Article */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            image: article.imageUrl,
            author: {
              '@type': 'Person',
              name: article.author,
            },
            datePublished: article.date,
            dateModified: article.date,
            publisher: {
              '@type': 'Organization',
              name: '51吃瓜网站',
              url: 'http://kanpian51.cn/',
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': `http://kanpian51.cn/article/${article.id}`,
            },
            articleSection: article.category,
            keywords: article.tags.join(', '),
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://kanpian51.cn/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: article.category,
                  item: `http://kanpian51.cn/category/${article.categorySlug}`,
                },
                {
                  '@type': 'ListItem',
                  position: 3,
                  name: article.title,
                },
              ],
            },
          }),
        }}
      />

      <Footer />
    </>
  );
}